import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
export const CHECKOUT_URL = 'https://megapack-fiesta-epica.impultienda.ar/checkout';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg'
}: Props) {
  const pad = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <a href={href} className={cn('group inline-flex items-center justify-center gap-2 rounded-full bg-iris font-extrabold uppercase tracking-wide text-white shadow-[0_10px_40px_-8px_rgba(124,92,245,0.65)] ring-1 ring-iris-soft/40 transition-all duration-200 hover:-translate-y-0.5 hover:bg-iris-deep hover:shadow-[0_16px_50px_-8px_rgba(124,92,245,0.8)] focus:outline-none focus-visible:ring-2 focus-visible:ring-iris-soft', pad, 'mt-[-10px] mb-[-10px] text-[#F3EFFE] text-[18px] pt-[17px] pb-[17px]', className)} data-id="element-49" data-mp="2p0jc5qgdk8dc">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-50" data-mp="1dahzh09s66hf" />
    </a>;
}